module.exports = __webpack_public_path__ + "media/images/top/howto-01-d202f30a3aa28d2f5b4f25551bf2a45a.svg";